/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Platform API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateSupplierRequest,
  DeleteStonePathParameters,
  DeleteSupplierPathParameters,
  GetStonePathParameters,
  ListStones200,
  ListStonesParams,
  ListSuppliers200,
  Stone,
  StoneImportRequest,
  StoneImportResult,
  Supplier,
  UpdateSupplierPathParameters,
  UpdateSupplierRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Stone suppliers of the shared pool
 */
export const listSuppliers = (

 options?: SecondParameter<typeof customInstance<ListSuppliers200>>,) => {
      return customInstance<ListSuppliers200>(
      {url: `/platform/v1/suppliers`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Add a stone supplier
 */
export const createSupplier = (
    createSupplierRequest: BodyType<CreateSupplierRequest>,
 options?: SecondParameter<typeof customInstance<Supplier>>,) => {
      return customInstance<Supplier>(
      {url: `/platform/v1/suppliers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSupplierRequest
    },
      options);
    }
  /**
 * @summary Update a stone supplier
 */
export const updateSupplier = (
    { id }: UpdateSupplierPathParameters,
    updateSupplierRequest: BodyType<UpdateSupplierRequest>,
 options?: SecondParameter<typeof customInstance<Supplier>>,) => {
      return customInstance<Supplier>(
      {url: `/platform/v1/suppliers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSupplierRequest
    },
      options);
    }
  /**
 * @summary Delete a stone supplier
 */
export const deleteSupplier = (
    { id }: DeleteSupplierPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/platform/v1/suppliers/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary The shared stone pool, newest first
 */
export const listStones = (
    params?: ListStonesParams,
 options?: SecondParameter<typeof customInstance<ListStones200>>,) => {
      return customInstance<ListStones200>(
      {url: `/platform/v1/stones`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary A stone from the shared pool
 */
export const getStone = (
    { id }: GetStonePathParameters,
 options?: SecondParameter<typeof customInstance<Stone>>,) => {
      return customInstance<Stone>(
      {url: `/platform/v1/stones/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Remove a stone from the shared pool
 */
export const deleteStone = (
    { id }: DeleteStonePathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/platform/v1/stones/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Load stones into the shared pool from CSV, upserting by supplier and stone number
 */
export const importStones = (
    stoneImportRequest: BodyType<StoneImportRequest>,
 options?: SecondParameter<typeof customInstance<StoneImportResult>>,) => {
      return customInstance<StoneImportResult>(
      {url: `/platform/v1/stones/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stoneImportRequest
    },
      options);
    }
  export type ListSuppliersResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type CreateSupplierResult = NonNullable<Awaited<ReturnType<typeof createSupplier>>>
export type UpdateSupplierResult = NonNullable<Awaited<ReturnType<typeof updateSupplier>>>
export type DeleteSupplierResult = NonNullable<Awaited<ReturnType<typeof deleteSupplier>>>
export type ListStonesResult = NonNullable<Awaited<ReturnType<typeof listStones>>>
export type GetStoneResult = NonNullable<Awaited<ReturnType<typeof getStone>>>
export type DeleteStoneResult = NonNullable<Awaited<ReturnType<typeof deleteStone>>>
export type ImportStonesResult = NonNullable<Awaited<ReturnType<typeof importStones>>>
